;
/*!
 * subitotexto.survey.js
 */
SubitoTexto.survey = {
	init               : function () {
		var $ = jqPla,
			_this = SubitoTexto.survey;

		_this.$surveys = $( '.survey-container' ).not( '.voted' );

		_this.modernBrowser = $( 'html' ).hasClass( 'preserve3d' );

		if ( _this.$surveys.length > 0 ) {

			_this.repairInputNames();

			new Fingerprint2( {
				excludeAvailableScreenResolution: true,
				excludeScreenResolution         : true
			} ).get( function ( result, components ) {
				_this.fingerprint = result;
			} );


			_this.$btnSurveySubmit = _this.$surveys.find( '.survey-send' );
			_this.bindEvents();

			//_this.alreadyVoted();

		}
	},
	// Undo the evil that .Net does to name attributes
	repairInputNames   : function () {
		var $ = jqPla,
			_this = SubitoTexto.survey;

		_this.$surveys.each( function ( i, el ) {
			$( this ).find( '.survey-checkbox' ).each( function ( j, jel ) {
				var $this = $( this ),
					wantedName = $this.data( 'wanted-name' );

				if ( wantedName ) {
					$this.attr( 'name', wantedName );
				}
			} );
		} );
	},
	bindEvents         : function () {
		var $ = jqPla,
			_this = SubitoTexto.survey;

		_this.$surveys.on( 'click touchstart', '.survey-checkboxlabel', function ( e ) {

			var $this = $( this ),
				$surveyContainer = $( this ).parents( '.survey-container' ),
				$radios = $surveyContainer.find( 'li' ).find( 'input[type=radio]' ),
				$labels = $surveyContainer.find( 'li' ).find( 'label' ),
				clickedFor = $this.attr( 'for' ),
				$partnerRadio = $radios.filter( '#' + clickedFor );


			// Fixing iOS bug:
			$radios.not( $partnerRadio ).attr( 'checked', '' );
			$radios.attr( 'checked', 'checked' );

			_this.hideWarning( $surveyContainer.find( '.survey-error.error-none-chosen' ) );

		} );


		_this.$surveys.on( 'focus', '.survey-checkbox', function ( e ) {
			PLA.UTILS.scrollTop.scrollTo( $( this ), -10 );
		} );


		_this.$btnSurveySubmit.on( 'click', function ( e ) {

			// One click/vote at a time, please
			if ( $( this ).hasClass( 'voting' ) || $( this ).parents( '.survey-container' ).hasClass( 'voted' ) ) {
				return;
			}

			var $voteOption = _this.voteValidate( $( this ) );


			if ( $voteOption.length > 0 ) {
				_this.ajaxVote( $voteOption );
			} else {
				_this.displayWarning( $( this ).siblings( '.survey-error.error-none-chosen' ) );
			}
		} );


		var debounceResizeResults = PLA.UTILS.debounce( function () {
			_this.resizeResultsAdjust();
		}, 250 );

		window.addEventListener( 'resize', debounceResizeResults );
	},
	displayWarning     : function ( $error ) {
		var $ = jqPla,
			_this = SubitoTexto.survey;

		if ( $error.length > 0 ) {
			$error.slideDown();
		}

	},
	hideWarning        : function ( $error ) {
		var $ = jqPla,
			_this = SubitoTexto.survey;

		if ( $error.length > 0 ) {
			$error.slideUp( 'fast' );
		}
	},
	voteValidate       : function ( $clicked ) {
		var $ = jqPla,
			_this = SubitoTexto.survey;

		var canSubmit = false,
			$surveyContainer = $clicked.parents( '.survey-container' ),
			$choices = $surveyContainer.find( '.survey-checkbox' ),
			$chosenOption = $choices.filter( ':checked' );

		return $chosenOption;

	},
	ajaxVote           : function ( $clicked ) {
		var $ = jqPla,
			_this = SubitoTexto.survey;

		var $surveyContainer = $clicked.parents( '.survey-container' ),
			surveyId = $surveyContainer.data( 'survey-id' ),
			$choices = $surveyContainer.find( '.survey-checkbox' ),
			$chosenOption = $choices.filter( ':checked' ),
			choiceId = $chosenOption.val();

		$clicked.addClass( 'voting' );

		$surveyContainer.find( '.survey-error' ).not( '.error-none-chosen' ).remove();

		$.ajax( {
			data    : {
				action     : 'surveyVote',
				survey_id  : surveyId,
				choice_id  : choiceId,
				fingerprint: _this.fingerprint
			},
			dataType: 'json',
			type    : 'post',
			url     : CONFIG.vote_surveys_url
		} ).done( function ( _data ) {

			$clicked.removeClass( 'voting' );
			$surveyContainer.addClass( 'voted' );

			if ( _data.success == 1 ) {

				Cookies.set( 'survey-vote-' + surveyId, choiceId, { expires: 365 } );
				_this.displayResults( _data.data, $surveyContainer );

			} else {
				if ( typeof _data.errors != 'undefined' && _data.errors.length > 0 ) {
					for ( var i = 0; i < _data.errors.length; i++ ) {
						if ( typeof _data.errors[ i ][ 'global' ] != 'undefined' ) {
							var errorText = _data.errors[ i ][ 'global' ],
								$errorContainer = $( '<div class="survey-error">' + errorText + '</div>' ).insertBefore( $surveyContainer.find( '.survey-send' ) );

							$errorContainer.show();
						}

					}
				}
			}

		} );


	},
	alreadyVoted       : function () {
		var $ = jqPla,
			_this = SubitoTexto.survey;

		// Theoretically, we shouldn't get here because the Cookies would have been read by the server and display a "voted" section
		_this.$surveys.each( function () {
			var $this = $( this ),
				surveyId = $this.data( 'survey-id' ),
				cookieValue = Cookies.get( 'survey-vote-' + surveyId );

			if ( cookieValue ) {
				var $choices = $this.find( '.survey-checkbox' ),
					$cookieChoice = $choices.filter( '[value="' + cookieValue + '"]' );

				//console.log('re-voting', cookieValue, $cookieChoice);

				if ( $cookieChoice.length > 0 ) {
					$cookieChoice.prop( 'checked', true );
					$this.addClass( 'voted' );
				}
			}
		} );
	},
	displayResults     : function ( results, $surveyContainer ) {
		var $ = jqPla,
			_this = SubitoTexto.survey;

		if ( typeof results[ 'htmlOut' ] != 'undefined' ) {

			var $votingChoicesSection = $surveyContainer.find( '.voting-results-container' );

			$votingChoicesSection.wrap( '<div class="perspective-container" />' );

			var $perspectiveContainer = $surveyContainer.find( '.perspective-container' )
			$perspectiveContainer.append( results[ 'htmlOut' ] );


			var $votingResultsSection = $perspectiveContainer.find( '.survey-results' );
			var iChoicesHeight = $perspectiveContainer.outerHeight(),
				iResultsHeight = $votingResultsSection.outerHeight(),
				iTallest = iChoicesHeight > iResultsHeight ? iChoicesHeight : iResultsHeight;


			setTimeout( function () {
				$surveyContainer.addClass( 'results-ready' );
				$perspectiveContainer.height( iResultsHeight );


				if ( $( window ).width() < 1200 ) {
					PLA.UTILS.scrollTop.scrollTo( $votingResultsSection, -40 );
				}

			}, 10 );

			// Special animations for bar graphs
			if ( $surveyContainer.hasClass( 'text-only' ) ) {

				var $resultBars = $surveyContainer.find( '.survey-bar' )

				$resultBars.each( function ( i, el ) {
					var $this = $( this ),
						desiredWidth = parseInt( $this[ 0 ].style.width, 10 );

					$this[ 0 ].style.width = 0;
					$this.data( 'desired-width', desiredWidth );
				} );


				if ( _this.modernBrowser ) {
					setTimeout( function () {
						$resultBars.each( function ( i, el ) {
							var $this = $( this ),
								desiredWidth = $this.data( 'desired-width' );

							$this.addClass( 'animated' );

							$this[ 0 ].style.width = desiredWidth + "%";


						} );
					}, 1000 );

				} else {
					// IE and such fallback
					$resultBars.each( function ( i, el ) {
						var $this = $( this ),
							desiredWidth = $this.data( 'desired-width' );

						$this.animate( {
							width: desiredWidth + "%"
						} );

					} );
				}


			}
		}
	},
	resizeResultsAdjust: function () {
		var $ = jqPla,
			_this = SubitoTexto.survey;


		_this.$surveys.each( function ( i, el ) {
			var $this = $( this ),
				$resultsSection = $this.find( '.perspective-container' ).find( '.survey-results' ), // Might be empty || !exist
				iResultsHeight = false;

			if ( $resultsSection.length > 0 ) {
				iResultsHeight = $resultsSection.outerHeight();

				$this.find( '.perspective-container' ).css( {
					height: iResultsHeight
				} );
			}

		} );
	}
};

